/**
 * Auth Service exports
 */

export { AuthService } from './auth.service';
export type { LoginCredentials, AuthResponse, UserData } from './auth.service';

// Convenience singleton instance
import { AuthService } from './auth.service';

// Default export is the singleton instance
export default AuthService.getInstance(); 